{
  "slug": "iq-vs-creativity",
  "title": "IQ vs Creativity",
  "description": "Reasoning and creativity can relate, but originality, expertise, motivation, and environment are not reducible to IQ.",
  "category": "Comparisons",
  "sections": [
    {
      "heading": "Purpose",
      "paragraphs": [
        "Reasoning and creativity can relate, but originality, expertise, motivation, and environment are not reducible to IQ.",
        "Begin with purpose rather than asking which score is universally better."
      ]
    },
    {
      "heading": "Measurement differences",
      "paragraphs": [
        "Compare content, limits, norms, reliability, validity, preparation, and decision rules.",
        "Correlation does not make measures interchangeable."
      ]
    },
    {
      "heading": "What to use",
      "paragraphs": [
        "Use evidence validated for the question. Admissions, clinical evaluation, grades, creativity, and emotion need different evidence.",
        "Do not convert scores without a justified publisher method."
      ]
    }
  ],
  "related": ["iq-vs-intelligence", "iq-vs-eq", "how-is-iq-measured"],
  "sources": [],
  "faqs": [],
  "summary": "Reasoning and creativity can relate, but originality, expertise, motivation, and environment are not reducible to IQ. Content reviewed 18 July 2026."
}
